module.exports = __webpack_public_path__ + "static/media/386.b935be7a.png";